const localizers = {
  'loading.msg': () => `Cargando...`,
  'SASServer.genericError.msg': () => `No se puede acceder al servidor.`,
  'SASReport.genericError.msg': () => `No se puede cargar el informe seleccionado.`,
  'SASReportImage.genericError.msg': () => `La imagen del informe no se ha cargado.`,
  'SASReportImage.imageNotSupported.msg': () => `Las imágenes no están soportadas para este tipo de contenido de informe.`,
}
export default localizers;
